import { useEffect, useState } from 'react';

import { getNetworkElementConfigurationLatest } from '@api/manageNetworkElementConfigurations';

import { handleErrorFromMessage } from '@utils/handleRequestError';

import { IResponseError } from '@interfaces/errors/apiErrors';
import {
	INetworkElementConfigurationIdentifier,
	INetworkElementConfigurationView,
} from '@interfaces/networkElementConfigurations/networkElementConfigurations';

import { EErrorCodes } from '@enums/errorCodes';

interface IUseQueryNetworkElementConfigurationLatestReturned {
	latestNetworkElementConfiguration?: INetworkElementConfigurationView;
	isLoadingNetworkElementConfigurationLatest: boolean;
}

const useQueryNetworkElementConfigurationLatest = (
	params: INetworkElementConfigurationIdentifier,
): IUseQueryNetworkElementConfigurationLatestReturned => {
	const [isLoading, setIsLoading] = useState(false);
	const [
		latestNetworkElementConfiguration,
		setLatestNetworkElementConfiguration,
	] = useState<INetworkElementConfigurationView | undefined>();

	useEffect(() => {
		setIsLoading(true);

		getNetworkElementConfigurationLatest(params)
			.then((respData) => {
				setLatestNetworkElementConfiguration(respData);
			})
			.catch((err: IResponseError) => {
				if (!err.errors.find((item) => item.code === EErrorCodes.assetSubTypeNameMustBeUnique)) {
					handleErrorFromMessage(err);
				}
			})
			.finally(() => setIsLoading(false));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [
		params.middlewareId,
		params.networkElementId,
	]);

	return {
		latestNetworkElementConfiguration,
		isLoadingNetworkElementConfigurationLatest: isLoading,
	};
};

export default useQueryNetworkElementConfigurationLatest;
